module.exports = __webpack_public_path__ + "static/media/vip.2ea3e180.svg";